module.exports = __webpack_public_path__ + "static/media/topbfg.5c95f365.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/topbfg.png
// module id = 1193
// module chunks = 0